import React, { useState, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Template from './template';
import { MoveCleaningUserRegister } from 'components';

import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { ProfileRegisterAction, ProfileRegisterState } from './store';
import { ServiceState, ServiceAction } from 'stores/ServiceStore';

import { apiMoveCleaningRegister } from 'api/ZimssaAPI';

import { SERVICE_SELECT } from 'router/PageUrl';
import ZimssaConstant, { GUIDE_TYPE, UPLOAD_TYPE, SERVICE_TYPE } from 'commons/ZimssaConstant';
import {
  getYear,
  validateInput,
  validationEmailDomain,
  getBusinessLicenseWithHyphen,
} from 'commons/ZimssaHelper';
import {
  PLACEHOLDER_EMAIL_1,
  PLACEHOLDER_EMAIL_2,
  SELECT_DEFAULT_CARRIERYEAR,
  BUTTON_COMPLETE,
} from 'commons/ZimssaString';

function MoveCleaningProfileRegisterView(): React.ReactElement {
  const history = useHistory();

  const [email1, setEmail1] = useState<string>('');
  const [email2, setEmail2] = useState<string>('');
  const [email3, setEmail3] = useState<string>('');

  const profileDispatcher = useContext(ProfileRegisterAction);
  const serviceDispatcher = useContext(ServiceAction);

  const { partnerIdx } = useContext(PartnerAuthState);
  const { serviceImages, carrierYear } =
    useContext(ProfileRegisterState);

  const {
    serviceName,
    serviceImage,
    introduce,
    startYear,
    businessRegistrationNumber,
    businessRegistrationImage,
    businessRegistrationOwner,
    taxClassification,
    familyRelationImage,
    location1,
    location2,
    serviceValid,
  } = useContext(ServiceState);

  const profileRegisterProps = {
    serviceImages: {
      serviceType: SERVICE_TYPE.MOVE_CLEANING,
      type: GUIDE_TYPE.FIELD_PHOTO,
      uploadType: UPLOAD_TYPE.MULTIPLE,
      inputName: 'serviceImages',
      imgDir: ZimssaConstant.IMG_DIR.PARTNER_USER.PROFILE.replace(
        '{{partnerIdx}}',
        `${partnerIdx}`
      ),
      guideMessageList: [
        '고객님이 보는 파트너 소개 페이지에 노출됩니다. 여러장의 멋진 활동 사진을 올려 고객님으로부터 선호도를 높여보세요.',
        '휴대전화 번호와 같이 개인정보가 노출되거나 그외 업체 홍보에 부적절한 사진은 심사를 통해 사진 등록이 제한될 수 있습니다.',
        '한 번에 업로드 가능한 최대 이미지의 용량은 10MB이며 JPG, PNG 확장자의 이미지 파일만 업로드 가능합니다.',
        '용량을 초과할 경우 업로드가 제한될 수 있습니다.'
      ],
      onChangeHandler: useCallback(
        (values: string[]) => {
          profileDispatcher({
            type: 'serviceImages',
            value: values,
          });
        },
        [profileDispatcher]
      ),
    },
    emailProps: {
      isDirectEmailEntry: email2 === '직접입력' || email2 === '',
      email1: {
        inputName: 'email1',
        placeholder: PLACEHOLDER_EMAIL_1,
        valid: false,
        value: email1,
        onChange: useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
          const { value } = e.target;
          setEmail1(value);
        }, []),
      },
      email2: {
        inputName: 'email2',
        value: email2,
        children: ZimssaConstant.EMAIL_LIST,
        onChangeHandler: useCallback((type: any, value: string) => {
          if (value !== '직접입력') {
            setEmail3('');
          }
          setEmail2(value);
        }, []),
      },
      email3: {
        inputName: 'email3',
        placeholder: PLACEHOLDER_EMAIL_2,
        value: email3,
        isValid: true,
        onChange: useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
          const { value } = e.target;
          setEmail3(value);
        }, []),
      },
    },
    carrierYear: {
      inputName: 'carrierYear',
      value: carrierYear ? carrierYear : 0,
      children: [
        { name: SELECT_DEFAULT_CARRIERYEAR, value: 0 },
        ...getYear(100),
      ],
      onChangeHandler: useCallback(
        (type: any, value: string) => {
          profileDispatcher({
            type: 'carrierYear',
            value: value,
          });
        },
        [profileDispatcher]
      ),
    },
    btnNext: {
      contents: BUTTON_COMPLETE,
      isActive: (() => {
        if (
          validateInput(email1 ? email1.trim() : '') &&
          (email2 !== '직접입력' || validationEmailDomain(email3)) &&
          validateInput(carrierYear)
        ) {
          return serviceImages.every((image) => validateInput(image.trim()));
        } else {
          return false;
        }
      })(),
      onClick: useCallback(
        () => {
          if (serviceValid) {
            apiMoveCleaningRegister({
              service: {
                serviceName: serviceName,
                serviceImage: serviceImage,
                introduce: introduce,
                startYear: startYear,
                businessRegistrationNumber: getBusinessLicenseWithHyphen(
                  businessRegistrationNumber
                ),
                businessRegistrationImage: businessRegistrationImage,
                businessRegistrationOwner: businessRegistrationOwner,
                taxClassification: taxClassification,
                familyRelationImage: familyRelationImage,
                location1: location1,
                location2: location2,
              },
              serviceType: 'move_cleaning',
              user: {
                profileImage: '',  // NOTE: 프로필 사진 등록 대신 활동 사진 복수 등록으로 바뀌며 빈 값으로 넘겨줌. 추후 백엔드에서 수정사항이 생길 경우 삭제 요망. - skkim
                email: `${email1.trim()}@${
                  email3 === '' ? email2 : email3.trim()
                }`,
              },
              moveCleaningProductInfo: { // NOTE: 평단가 영역 숨김 처리 작업. 추후 개선사항이 나오면 수정할 예정 - skkim
                sizeTo: 0,
                unitPrice: 0,
                fixedPrice: 0,
              },
              serviceUserInfo: {
                carrierYear,
              },
              serviceImages,
            }).then((response) => {
              const { result, message } = response;
              if (result === 'success') {
                alert('서류 제출을 완료 하였습니다.');
                serviceDispatcher({
                  type: 'INIT_STATE',
                });
                history.push(SERVICE_SELECT.url);
              } else {
                if (message) alert(message);
              }
            });
          }
        },
        [
          carrierYear,
          email1,
          email2,
          email3,
          history,
          serviceImages,
          serviceName,
          serviceImage,
          introduce,
          startYear,
          businessRegistrationNumber,
          businessRegistrationImage,
          businessRegistrationOwner,
          taxClassification,
          familyRelationImage,
          location1,
          location2,
        ]
      ),
    },
  };

  return (
    <Template>
      <MoveCleaningUserRegister {...profileRegisterProps} />
    </Template>
  );
}

export default MoveCleaningProfileRegisterView;
